<script setup lang="ts">
import PageMeta from "../../components/PageMeta";
</script>

<!--
  TODO: missing elements:
  - product name
  - editor info
  - publishing info
  - hosting provider info
  - accessibility info
 -->
<template>
  <PageMeta
    title="Mentions légales"
    description="Mentions légales du site aram.aplusb.pro"
  />

  <section class="fr-my-0 fr-mx-auto content">
    <h1>Mentions légales</h1>

    <p>
      Ce site est édité par l’équipe
        Services numériques de l'entreprise <a
        href="https://www.aplusb.pro"
        rel="noreferrer noopener"
        target="_blank">AplusB</a>.
    </p>
    <p>
      AplusB<br/>
      SARL au capital social de 12 000 €<br />
      Immatriculée au Registre du Commerce et des Sociétés de Paris sous le numéro 525 329 918<br/>
      Numéro de TVA intracommunautaire : FR17 525 329 918<br/>
      10 villa des Nymphéas<br/>
      75020 Paris<br />
      Téléphone : 06 30 08 28 85<br />
      SIREN : 525 329 918<br />
    </p>

    <h2>Directeur de publication</h2>
    <p>Brice Kovács – contact@aplusb.pro</p>
    <h2>Conception et gestion du site</h2>
    <p>
      Ce site est conçu et développé par <a         href="https://yann.lossouarn.net/"
        rel="noreferrer noopener"
        target="_blank">Yann Lossouarn</a>, de l'entreprise AplusB dans le cadre d'une Réutilisation avec modification d'Ara, un outil proposé par les services de la DINUM.
    </p>

    <h2>Hébergement du site</h2>

    <p>
      Ce site est auto-hébergé par l'entreprise AplusB.
    </p>

    <h2>Propriété intellectuelle et liens</h2>
    <p>
      Tout site public ou privé est autorisé à établir, sans autorisation
      préalable, un lien vers les informations diffusées sur
      aram.aplusb.pro.
    </p>
    <p>
      Sauf mention de propriété intellectuelle détenue par des tiers, les
      contenus de ce site sont proposés sous licence ouverte 2.0.
    </p>
    <p>
      La mise en place de liens vers nos contenus et documents est cependant est
      à privilégier par rapport à la reproduction sur un site tiers. La mention
      explicite du site source aram.aplusb.pro est recommandée.
    </p>
  </section>
</template>

<style scoped>
.content {
  max-width: 49.5rem;
}
</style>
